// eslint-disable-next-line
const NOT_AVAILABLE = 'N/A';
const CURRENCY = '€';
const RECURRENCE = '/mês';

const MOBILE_NAMESPACES = [
  'movel',
  'movel_adicionais',
  'plano'
];

const generateExtraItems = (_items) => {
  const extraItems = _items.map((i) => {
    if (i.meta.fis.type !== 'base') {
      return undefined;
    }

    return `<p>Inclui ${i.meta.fis.title}</p>`;
  });

  return extraItems.join('');
};

const generateSoftExtraItems = (_items) => {
  const extraItems = _items.map(i => `<p>Inclui ${i}</p>`);

  return extraItems.join('');
};

const generateItem = (_namespace, _title, _rootGetters, _extraItems = null, _includePath = null) => {
  const activeItem = _rootGetters['cart/activeItemsInNamespace'](_namespace).filter(i => i.meta.fis && !i.meta.fis.mergeWith);
  const mobileItem = activeItem.filter(i => i.path.includes('plano'));
  const chosenNumber = mobileItem[mobileItem.length - 1];
  const mobileFixoItem = activeItem.filter(m => m.path.includes('movel'));
  const chosenFixoMobile = mobileFixoItem[mobileFixoItem.length - 1];

  // No need for this after the campaign endeds
  // Has 15gb fidelization discount (NET250 + TV FAMILIA + TLF + 15GB MOVEL)
  const fidelizationDiscount = 'Desconto de 5€ durante fidelização';
  const fidelization15gbCampaignDiscount = _rootGetters['offers/getValidDiscountOffers'].filter(i => i.description === fidelizationDiscount);
  const mobile15Gg = mobileFixoItem.filter(m => m.path.includes('gb_15'));

  const item = activeItem.length ? activeItem.map((i) => {
    if (_namespace === 'plano') {
      if (i.path === chosenNumber.path) {
        return `${i.meta.fis.title_description}`;
      }
      return '';
    }

    if (_namespace === 'movel') {
      if (fidelization15gbCampaignDiscount.length && i.path.includes('gb_15')) {
        return `${mobile15Gg[0].meta.fis.title_description}`;
      }
      if (!fidelization15gbCampaignDiscount.length && i.path === chosenFixoMobile.path) {
        return `${i.meta.fis.title_description}`;
      }
      return '';
    }

    return `${i.meta.fis.title}`;
  }).join('') : `${NOT_AVAILABLE}`;
  let extra = '';

  if (_includePath && _rootGetters['cart/getPath'](_includePath)) {
    const mergeableItems = _rootGetters['cart/getActiveItems'].filter(i => i.meta.fis && i.meta.fis.mergeWith === _includePath);
    const mergedItems = mergeableItems.length ? mergeableItems.map(i => ` com ${i.meta.fis.title}`).join('') : '';

    extra = `Inclui ${_rootGetters['cart/getPath'](_includePath).meta.fis.title}${mergedItems}`;
  }

  extra = activeItem.length ? `${extra}${generateExtraItems(_rootGetters['cart/activeItemsInNamespace'](activeItem[0].config.name).filter(i => i.meta.fis && !i.meta.fis.mergeWith))}` : extra;

  if (activeItem.length && _extraItems) {
    extra = `${generateSoftExtraItems(_extraItems)}${extra}`;
  }

  const policy = MOBILE_NAMESPACES.includes(_namespace) ? '<br />Política de utilização responsável em roaming disponível para consulta na secção 5.1 em <a href="https://www.nowo.pt/pdf/Condicoes-de-Oferta-dos-Servicos.pdf" target="_blank/"> nowo.pt/pdf/Condicoes-de-Oferta-dos-Servicos.pdf</a>' : '';
  return `<p class="title"><strong>${_title}</strong></p><p>${item}${extra}${policy}</p>`;
};

const generateAdditionalItems = (getters, _rootGetters) => {
  // Get all additional Services
  const items = _rootGetters['fis/getAdditionalServices'];
  // Get mobile items to determinate principal card (chosenNumber)
  const mobileItems = _rootGetters['cart/getActiveItems'].filter(i => i.path.includes('movel') || i.path.includes('plano'));
  const chosenNumber = mobileItems[mobileItems.length - 1];

  const isIpTv = _rootGetters['cart/getActiveItems'].filter(item => item.path === 'tv.components.chan_base' || item.path === 'tv.components.chan_advanced');
  let fidelization = _rootGetters['cart/namespaceExists']('permanencia') ? _rootGetters['cart/activeItemsInNamespace']('permanencia')[0].meta.code : 0;
  if (isIpTv) fidelization = 1;

  // Has 15gb fidelization discount (NET250 + TV FAMILIA + TLF + 15GB MOVEL)
  const fidelizationDiscount = 'Desconto de 5€ durante fidelização';
  const fidelization15gbCampaignDiscount = _rootGetters['offers/getValidDiscountOffers'].filter(i => i.description === fidelizationDiscount);
  // Has mobile discount campaign 1GB and 15GB mobile cards
  const mobileCampaign = _rootGetters['cart/getActiveItems'].filter(i => i.path.includes('gb_15') || i.path.includes('gb_1'));

  const additionalItems = [];

  const additionalMobileItems = new Set();

  items.forEach((item) => {
    let campaignDuration = '1º ao 12º mês';
    const hasMobileCampaign = mobileCampaign.filter(i => i.path.includes(item.path)).length;

    if (item.path.includes('movel') || item.path.includes('plano')) {
      if (item.path !== chosenNumber.path) {
        const additionalMobileCard = item.quantity > 1 && item.meta.fis.multiple_selection_title ?
          `${item.quantity} ${item.meta.fis.multiple_selection_title}` : item.meta.fis.title;
        const priceMobileAdditional = item.price.length ? _rootGetters['cart/getPathPrice'](item.path).value * item.quantity : 0;
        const priceMobileAdditionalWithoutDiscount = item.price.length ? item.price[item.price.length - 1].value * item.quantity : 0;
        const priceOldMobileAdditional = item.price.length ? _rootGetters['cart/getPathPrice'](item.path).old * item.quantity : 0;

        if (hasMobileCampaign && !additionalMobileItems.has(item) && item.path.includes('plano')) {
          additionalItems.push({
            item: `<p class="table-text">${additionalMobileCard}</p>`
          });

          additionalItems.push({
            item: `<p class="table-text"> Serviços e descontos incluídos do ${campaignDuration}</p>`,
            fidelization: item.meta.fis.noFidelization ? 0 : fidelization,
            price: `${CURRENCY} ${priceMobileAdditional.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            priceWithoutDiscount: `${CURRENCY} ${priceMobileAdditionalWithoutDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            discount: `${CURRENCY} ${(priceMobileAdditionalWithoutDiscount - priceMobileAdditional).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            installation: {
              label: `${additionalMobileCard}`,
              price: `${CURRENCY} 0,00 ${RECURRENCE}`,
              discount: `${CURRENCY} 0,00 ${RECURRENCE}`,
              priceWithoutDiscount: `${CURRENCY} 0,00 ${RECURRENCE}`
            }
          });

          campaignDuration = '13º ao 24º mês';

          additionalItems.push({
            item: `<p class="table-text"> Serviços e descontos incluídos do ${campaignDuration}</p>`,
            fidelization: item.meta.fis.noFidelization ? 0 : fidelization,
            price: `${CURRENCY} ${priceOldMobileAdditional.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            priceWithoutDiscount: `${CURRENCY} ${priceMobileAdditionalWithoutDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            discount: `${CURRENCY} ${(priceMobileAdditionalWithoutDiscount - priceOldMobileAdditional).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            installation: {
              label: `${additionalMobileCard}`,
              price: `${CURRENCY} 0,00 ${RECURRENCE}`,
              discount: `${CURRENCY} 0,00 ${RECURRENCE}`,
              priceWithoutDiscount: `${CURRENCY} 0,00 ${RECURRENCE}`
            }
          });
          // adding the item to the set so in next iteration it´s not goint to be repeat
          additionalMobileItems.add(item);
        } else {
          additionalItems.push({
            item: `<p class="table-text">${additionalMobileCard}</p>`,
            fidelization: item.meta.fis.noFidelization ? 0 : fidelization,
            price: `${CURRENCY} ${priceMobileAdditional.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            priceWithoutDiscount: `${CURRENCY} ${priceMobileAdditionalWithoutDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            discount: `${CURRENCY} ${(priceMobileAdditionalWithoutDiscount - priceMobileAdditional).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            installation: {
              label: `${additionalMobileCard}`,
              price: `${CURRENCY} 0,00 ${RECURRENCE}`,
              discount: `${CURRENCY} 0,00 ${RECURRENCE}`,
              priceWithoutDiscount: `${CURRENCY} 0,00 ${RECURRENCE}`
            }
          });
        }
      }

      if (item.path === chosenNumber.path) {
        // eslint-disable-next-line no-nested-ternary
        const mobileCard = (chosenNumber.quantity > 1 && chosenNumber.quantity !== 2) && (chosenNumber.meta.fis.multiple_selection_title) ?
          `${chosenNumber.quantity - 1} ${chosenNumber.meta.fis.multiple_selection_title}` : chosenNumber.meta.fis.title;
        let price = 0;
        let priceWithoutDiscount = 0;

        if (fidelization15gbCampaignDiscount.length) {
          price = chosenNumber.price.length && (chosenNumber.quantity > 1) ? _rootGetters['cart/getPathPrice'](item.path).value * (chosenNumber.quantity - 1) : _rootGetters['cart/getPathPrice'](item.path).value;
          priceWithoutDiscount = chosenNumber.price.length && (chosenNumber.quantity > 1) ? chosenNumber.price[chosenNumber.price.length - 1].value * (chosenNumber.quantity - 1) : chosenNumber.price[chosenNumber.price.length - 1].value;
        } else {
          price = chosenNumber.price.length && (chosenNumber.quantity > 1) ? _rootGetters['cart/getPathPrice'](item.path).value * (chosenNumber.quantity - 1) : 0;
          priceWithoutDiscount = chosenNumber.price.length && (chosenNumber.quantity > 1) ? chosenNumber.price[chosenNumber.price.length - 1].value * (chosenNumber.quantity - 1) : 0;
        }

        if (hasMobileCampaign && !additionalMobileItems.has(item) && item.path.includes('plano')) {
          additionalItems.push({
            item: `<p class="table-text">${mobileCard}</p>`
          });

          additionalItems.push({
            item: `<p class="table-text"> Serviços e descontos incluídos do ${campaignDuration}</p>`,
            fidelization: item.meta.fis.noFidelization ? 0 : fidelization,
            price: `${CURRENCY} ${price.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            priceWithoutDiscount: `${CURRENCY} ${priceWithoutDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            discount: `${CURRENCY} ${(priceWithoutDiscount - price).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            installation: {
              label: `${mobileCard}`,
              price: `${CURRENCY} 0,00 ${RECURRENCE}`,
              discount: `${CURRENCY} 0,00 ${RECURRENCE}`,
              priceWithoutDiscount: `${CURRENCY} 0,00 ${RECURRENCE}`
            }
          });

          price = chosenNumber.price.length && (chosenNumber.quantity > 1) ? _rootGetters['cart/getPathPrice'](item.path).old * (chosenNumber.quantity - 1) : 0;
          campaignDuration = ' 13º ao 24º mês';

          additionalItems.push({
            item: `<p class="table-text"> Serviços e descontos incluídos do ${campaignDuration}</p>`,
            fidelization: item.meta.fis.noFidelization ? 0 : fidelization,
            price: `${CURRENCY} ${price.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            priceWithoutDiscount: `${CURRENCY} ${priceWithoutDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            discount: `${CURRENCY} ${(priceWithoutDiscount - price).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            installation: {
              label: `${mobileCard}`,
              price: `${CURRENCY} 0,00 ${RECURRENCE}`,
              discount: `${CURRENCY} 0,00 ${RECURRENCE}`,
              priceWithoutDiscount: `${CURRENCY} 0,00 ${RECURRENCE}`
            }
          });

          additionalMobileItems.add(item);
        } else {
          additionalItems.push({
            item: `<p class="table-text">${mobileCard}</p>`,
            fidelization: chosenNumber.meta.fis.noFidelization ? 0 : fidelization,
            price: `${CURRENCY} ${price.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            priceWithoutDiscount: `${CURRENCY} ${priceWithoutDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            discount: `${CURRENCY} ${(priceWithoutDiscount - price).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
            installation: {
              label: `${mobileCard}`,
              price: `${CURRENCY} 0,00 ${RECURRENCE}`,
              discount: `${CURRENCY} 0,00 ${RECURRENCE}`,
              priceWithoutDiscount: `${CURRENCY} 0,00 ${RECURRENCE}`
            }
          });
        }
      }
    } else if (_rootGetters['offers/getValidDiscountOffers'].filter(i => i.description.includes(item.meta.title.item)).length) {
      /* added to meet wifi mesh campaign */
      // eslint-disable-next-line no-nested-ternary
      const itemName = (item.quantity > 1) && (item.meta.fis.multiple_selection_title) ?
        `${item.quantity} ${item.meta.fis.price_title_multiple}` :
        item.meta.fis.price_title ? item.meta.fis.price_title : item.meta.fis.title;
      const price = item.price.length ? _rootGetters['cart/getPathPrice'](item.path).value * item.quantity : item.price.value * item.quantity;
      const priceWithoutDiscounts = item.price.length ? item.price[item.price.length - 1].value * item.quantity : item.price.value * item.quantity;
      const validOffer = _rootGetters['offers/getValidDiscountOffers'].filter(i => i.description.includes(item.meta.title.item));
      const validOffersValue = validOffer.length ? validOffer[0].subject.value : 0;

      additionalItems.push({
        item: `<p class="table-text">${itemName}</p>`,
        fidelization: item.meta.fis.noFidelization ? 0 : fidelization,
        price: `${CURRENCY} ${(price - validOffersValue).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        priceWithoutDiscount: `${CURRENCY} ${priceWithoutDiscounts.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        discount: `${CURRENCY} ${(priceWithoutDiscounts - validOffersValue).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        installation: {
          label: `${itemName}`,
          price: `${CURRENCY} 0,00 ${RECURRENCE}`,
          discount: `${CURRENCY} 0,00 ${RECURRENCE}`,
          priceWithoutDiscount: `${CURRENCY} 0,00 ${RECURRENCE}`
        }
      });
    } else {
      // eslint-disable-next-line no-nested-ternary
      const itemName = (item.quantity > 1) && (item.meta.fis.multiple_selection_title) ?
        `${item.quantity} ${item.meta.fis.price_title_multiple}` :
        item.meta.fis.price_title ? item.meta.fis.price_title : item.meta.fis.title;
      const price = item.price.length ? _rootGetters['cart/getPathPrice'](item.path).value * item.quantity : item.price.value * item.quantity;
      const priceWithoutDiscounts = item.price.length ? item.price[item.price.length - 1].value * item.quantity : item.price.value * item.quantity;

      additionalItems.push({
        item: `<p class="table-text">${itemName}</p>`,
        fidelization: item.meta.fis.noFidelization ? 0 : fidelization,
        price: `${CURRENCY} ${price.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        priceWithoutDiscount: `${CURRENCY} ${priceWithoutDiscounts.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        discount: `${CURRENCY} ${(priceWithoutDiscounts - price).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        installation: {
          label: `${itemName}`,
          price: `${CURRENCY} 0,00 ${RECURRENCE}`,
          discount: `${CURRENCY} 0,00 ${RECURRENCE}`,
          priceWithoutDiscount: `${CURRENCY} 0,00 ${RECURRENCE}`
        }
      });
    }
  });

  return additionalItems;
};

export const generateServiceName = (_rootGetters) => {
  const items = _rootGetters['cart/getActiveItems'].filter(item => item.meta.title.name);
  let serviceName = '';

  items.forEach((item) => {
    if (serviceName.length) serviceName += '; ';
    serviceName += item.quantity > 1 ? `${item.quantity} ${item.meta.title.name}` : item.meta.title.name;
  });

  return serviceName;
};

export const generateIncludedPriceWithoutDiscount = (getters, _rootGetters) => {
  const hasPeriodicPrice = _rootGetters['offers/getValidExternalOffers'].filter(item => item.subject.isPeriodic);
  let priceWithoutDiscount = 0;

  if (hasPeriodicPrice.length) {
    priceWithoutDiscount = getters.getTotalBaseServicesPrice * 2;
  }

  return priceWithoutDiscount;
};

export const generateIncludedPrice = (getters, _rootGetters) => {
  const hasPeriodicPrice = _rootGetters['offers/getValidExternalOffers'].filter(item => item.subject.isPeriodic);

  if (hasPeriodicPrice.length) {
    return getters.getTotalBaseServicesPrice / 2;
  }

  return getters.getTotalBaseServicesPrice;
};

export const generateIncludedDiscount = (getters, _rootGetters) => getters.getTotalBaseServicesPrice - generateIncludedPrice(getters, _rootGetters);

export const generateIncludedTotal = (getters, _rootGetters) => {
  // Periodic Offer
  const hasPeriodicOffer = _rootGetters['offers/getValidDiscountOffers'].filter(item => item.subject.isPeriodic);

  // Check if it is Carregamentos
  const isChargeOption = getters.getBaseServices[0].path.includes('carregamentos');

  if (isChargeOption) {
    return [
      {
        label: 'N/A',
        price: '€ 0,00 /mês',
        discount: '€ 0,00 /mês',
        priceWithoutDiscount: '€ 0,00 /mês'
      }
    ];
  }

  const totals = [];

  const mobileItems = _rootGetters['cart/getActiveItems'].filter(i => i.path.includes('movel') || i.path.includes('plano'));
  const chosenNumber = mobileItems.length ? mobileItems[mobileItems.length - 1] : null;
  const chosenBasePrice = mobileItems.length ? chosenNumber.price[chosenNumber.price.length - 1].value : 0;

  if (getters.getBaseServices[0].path.includes('pospago')) {
    let chosenPriceWithDiscount = chosenNumber.price[0].value;

    const ddCost = _rootGetters['cart/getActiveItems'].filter(item => item.path.includes('debitodireto')).length ? 0 : 1;
    const feCost = _rootGetters['cart/getActiveItems'].filter(item => item.path.includes('digital')).length ? 0 : 1;

    chosenPriceWithDiscount += ddCost + feCost;

    const hasFidelization = _rootGetters['cart/getActiveItems'].filter(item => item.path.includes('months_24')).length ? 1 : 0;

    const totalDiscount = hasFidelization > 0 ? chosenBasePrice - chosenPriceWithDiscount : 0;
    const totalPrice = hasFidelization > 0 ? chosenPriceWithDiscount : chosenBasePrice;

    if (hasPeriodicOffer.length && (chosenNumber.path.includes('gb_15') || chosenNumber.path.includes('gb_1'))) {
      totals.push(
        {
          label: 'Serviços e equipamentos incluídos 1º ao 12º mês',
          price: `${CURRENCY} ${totalPrice.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          priceWithoutDiscount: `${CURRENCY} ${chosenBasePrice.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          discount: `${CURRENCY} ${totalDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`
        }
      );

      const chosenBasePriceOld = chosenNumber.price[0].old;
      const discAfterPeriod = chosenBasePrice - chosenBasePriceOld;

      totals.push(
        {
          label: 'Serviços e equipamentos incluídos 13º ao 24º mês',
          price: `${CURRENCY} ${chosenBasePriceOld.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          priceWithoutDiscount: `${CURRENCY} ${chosenBasePrice.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          discount: `${CURRENCY} ${(discAfterPeriod).toFixed(2).replace('.', ',')} ${RECURRENCE}`
        }
      );
    } else {
      let chosenPriceWithoutOffers = chosenNumber.price[0].old ? chosenNumber.price[0].old : chosenNumber.price[0].value;

      chosenPriceWithoutOffers += ddCost + feCost;

      const priceWithouOffers = hasFidelization > 0 ? chosenPriceWithoutOffers : chosenBasePrice;
      const totalDiscountWithoutOffers = hasFidelization > 0 ? chosenBasePrice - chosenPriceWithoutOffers : 0;
      totals.push(
        {
          label: 'Serviços e equipamentos incluídos',
          price: `${CURRENCY} ${priceWithouOffers.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          priceWithoutDiscount: `${CURRENCY} ${chosenBasePrice.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          discount: `${CURRENCY} ${totalDiscountWithoutOffers.toFixed(2).replace('.', ',')} ${RECURRENCE}`
        }
      );
    }
  }

  // check if casa
  const packageName = _rootGetters['packages/getActivePackageMeta'].name;
  if (packageName.toLowerCase() === 'casa') {
    // Has 15gb & 1gb Campaign
    const mobileCampaign = _rootGetters['cart/getActiveItems'].filter(i => i.path.includes('gb_15') || i.path.includes('gb_1'));
    const chosenHasMobileCampaign = mobileCampaign.length ? (chosenNumber.path.includes('gb_15') || chosenNumber.path.includes('gb_1')) : null;
    // Has just 15gb campaign
    const mobile15GbCampaign = mobileCampaign.filter(i => i.path.includes('gb_15'));

    // Has 15gb fidelization discount (NET250 + TV FAMILIA + TLF + 15GB MOVEL)
    const fidelizationDiscount = 'Desconto de 5€ durante fidelização';
    const fidelization15gbCampaignDiscount = _rootGetters['offers/getValidDiscountOffers'].filter(i => i.description === fidelizationDiscount);

    // Mobile Base Price
    let chosenMobilePriceWithDiscount = 0;
    let chosenMobilePriceOld = 0;
    if (mobileItems.length) {
      // if 15gb campaign is eligible then the principal mobile card is allways the 15gb card even if there´s a 30gb card chosen, this override the logic that the biggest card is the principal card
      chosenMobilePriceWithDiscount = fidelization15gbCampaignDiscount.length ? mobile15GbCampaign[0].price[0].value : chosenNumber.price[0].value;

      // Price after ending 15gb || 1gb campaign discount period and forcing the 15gb as the chosen if fidelization15gbCampaignDiscount.length
      if (fidelization15gbCampaignDiscount.length) {
        chosenMobilePriceOld = mobile15GbCampaign[0].price[0].old;
      } else {
        chosenMobilePriceOld = mobileCampaign.length && chosenHasMobileCampaign ? chosenNumber.price[0].old : chosenNumber.price[0].value;
      }
    }

    // PREÇO BASE SEM DESCONTOS
    // removed the ternary if ending fidelization 15gb campaign and the need to force the 15gb has a principal card. Leaving just the end of the ternary
    const totalStandardPrice = fidelization15gbCampaignDiscount.length && !chosenHasMobileCampaign ? (getters.getTotalNonFidelizedBaseServicesPrice - chosenBasePrice) + mobile15GbCampaign[0].price[1].value : getters.getTotalNonFidelizedBaseServicesPrice;

    // PREÇO BASE COM DESCONTOS
    const totalBasePrice = getters.getTotalBaseServicesPrice;
    const totalBasePriceWithoutMobile = chosenNumber !== null ? totalBasePrice - chosenNumber.price[0].value : totalBasePrice;

    if (hasPeriodicOffer.length) {
      // removed the mobile cards discounts, to simplify when we´ve more than one card and the principal card hasn´t any campaign.
      const validOffers = _rootGetters['offers/getValidDiscountOffers'].filter(offer => offer.description !== fidelizationDiscount && !offer.description.includes('Débito') && !offer.description.includes('Fatura') && !offer.description.includes('GB') && !offer.description.includes('MESH'));
      const validOffersDiscount = validOffers.length ? validOffers.map(offer => offer.subject.value).reduce((sum, x) => sum + x) : 0;
      // mobile cards discounts if available
      const mobileValidDiscount = mobileCampaign.length && chosenHasMobileCampaign ? (chosenMobilePriceOld - chosenMobilePriceWithDiscount) : 0;
      const periodicPrice = ((totalBasePriceWithoutMobile - validOffersDiscount) + chosenMobilePriceWithDiscount) - mobileValidDiscount;

      totals.push(
        {
          label: 'Serviços e equipamentos incluídos 1º ao 12º mês',
          price: `${CURRENCY} ${periodicPrice.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          priceWithoutDiscount: `${CURRENCY} ${totalStandardPrice.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          discount: `${CURRENCY} ${(totalStandardPrice - periodicPrice).toFixed(2).replace('.', ',')} ${RECURRENCE}`
        }
      );

      // check for silent offers ignoring DD and FE discount and taking it from de base value
      const validSilentOffers = _rootGetters['offers/getValidDiscountSilentOffers'].filter(offer => !offer.description.includes('Débito') && !offer.description.includes('Fatura') && !offer.description.includes('MESH'));
      const validSilentOffersValue = validSilentOffers.length ? validSilentOffers.map(offer => offer.subject.value).reduce((sum, x) => sum + x) : 0;
      const periodicPriceUntilFidelization = fidelization15gbCampaignDiscount.length && !chosenHasMobileCampaign ? (totalBasePriceWithoutMobile - validSilentOffersValue) + chosenMobilePriceOld : (((totalBasePrice - chosenMobilePriceOld) - validSilentOffersValue) + chosenMobilePriceOld);

      totals.push(
        {
          label: 'Serviços e equipamentos incluídos 13º ao 24º mês',
          price: `${CURRENCY} ${periodicPriceUntilFidelization.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          priceWithoutDiscount: `${CURRENCY} ${totalStandardPrice.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          discount: `${CURRENCY} ${(totalStandardPrice - periodicPriceUntilFidelization).toFixed(2).replace('.', ',')} ${RECURRENCE}`
        }
      );
    } else {
      const ddCost = _rootGetters['cart/getActiveItems'].filter(item => item.path.includes('debitodireto')).length ? 0 : 1;
      const feCost = _rootGetters['cart/getActiveItems'].filter(item => item.path.includes('digital')).length ? 0 : 1;

      const hasFidelization = _rootGetters['cart/getActiveItems'].filter(item => item.path.includes('months_24')).length ? 1 : 0;

      const fidelizationFlashDescription = 'durante fidelização';
      const fidelizationFlashDiscount = _rootGetters['offers/getValidDiscountOffers'].filter(i => i.description.includes(fidelizationFlashDescription));
      const fidelizationFlashDiscountValue = fidelizationFlashDiscount.length ? fidelizationFlashDiscount.map(i => i.subject.value).reduce((sum, x) => sum + x) : 0;

      // eslint-disable-next-line no-nested-ternary
      const price = hasFidelization > 0 ? (getters.getTotalBaseServicesPrice - fidelizationFlashDiscountValue) + ddCost + feCost : totalStandardPrice - getters.getTotalBaseServicesPrice;

      totals.push(
        {
          label: 'Serviços e equipamentos incluídos',
          price: `${CURRENCY} ${price.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          priceWithoutDiscount: `${CURRENCY} ${totalStandardPrice.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
          discount: `${CURRENCY} ${(totalStandardPrice - price).toFixed(2).replace('.', ',')} ${RECURRENCE}`
        }
      );
    }
  }

  return totals;
};

export const generateIncludedItems = (_rootGetters) => {
  const items = {};

  const tv = generateItem('tv', 'TELEVISÃO', _rootGetters, null, 'tv.children.premium.components.not_categorized.components.box');
  const internet = generateItem('internet', 'INTERNET FIXA', _rootGetters, ['Router WiFi']);
  const landline = generateItem('telefone', 'TELEFONE FIXO', _rootGetters);
  const mobile = generateItem(_rootGetters['cart/namespaceExists']('movel') ? 'movel' : 'plano', 'TELEFONE MÓVEL', _rootGetters);
  if (!tv.includes(`${NOT_AVAILABLE}`)) items.tv = tv;
  if (!internet.includes(`${NOT_AVAILABLE}`)) items.internet = internet;
  if (!landline.includes(`${NOT_AVAILABLE}`)) items.landline = landline;
  if (!mobile.includes(`${NOT_AVAILABLE}`)) items.mobile = mobile;

  return items;
};

export const getAdditionalServicesDescription = (_rootGetters) => {
  const items = _rootGetters['fis/getAdditionalServices'];
  const additionalServices = [];
  const tv = items.filter(item => item.path.includes('tv'));
  const internet = items.filter(item => item.path.includes('internet'));
  const additionalMobile = items.filter(item => item.path.includes('movel') || item.path.includes('plano'));
  const mobile = _rootGetters['cart/getActiveItems'].filter(i => i.path.includes('movel') || i.path.includes('plano'));
  const chosenMobile = mobile[mobile.length - 1];

  if (additionalMobile.length) {
    additionalServices.push(
      `<p class="title"><strong>TELEFONE MÓVEL</strong></p><p>${additionalMobile.map((item) => {
        if (item.path !== chosenMobile.path && item.quantity > 1) return (item.quantity > 1) && (item.meta.fis.multiple_selection_title) ? `${item.quantity} ${item.meta.fis.multiple_selection_title}` : item.meta.fis.title;
        if (item.path === chosenMobile.path && item.quantity > 2) return (item.quantity > 2) && (item.meta.fis.multiple_selection_title) ? `${item.quantity - 1} ${item.meta.fis.multiple_selection_title}` : item.meta.fis.title;
        if (item.path === chosenMobile.path && item.quantity === 2) return item.meta.fis.title.replace(1, item.quantity - 1);
        return item.meta.fis.title.replace(1, item.quantity);
      }).toString().replaceAll(',', '<br /> ')}<br />Política de utilização responsável em roaming disponível para consulta na secção 5.1 em <a href='https://www.nowo.pt/pdf/Condicoes-de-Oferta-dos-Servicos.pdf' target='_blank/'>nowo.pt/pdf/Condicoes-de-Oferta-dos-Servicos.pdf</a></p>`
    );
  }

  if (internet.length) {
    additionalServices.push(
      `<p class="title"><strong>INTERNET FIXA</strong></p><p>${internet.map(item => (item.meta.fis.description ? item.meta.fis.description : item.meta.fis.title)).toString().replaceAll(',', '; ')}</p>`
    );
  }

  if (tv.length) {
    additionalServices.push(
      `<p class="title"><strong>TELEVISÃO</strong></p><p>${tv.map(item => (item.meta.fis.description ? item.meta.fis.description : item.meta.fis.title)).toString().replaceAll(',', '; ')}</p>`
    );
  }

  if (!additionalServices.length) {
    additionalServices.push(
      '<p>N/A</p>'
    );
  }

  return additionalServices;
};

export const getInternetServiceCharges = (_rootGetters) => {
  const items = _rootGetters['fis/getBaseServices'];
  const internetServiceCharges = [];
  const internet = items.filter(item => item.path.includes('internet'));
  const movel = items.filter(item => item.path.includes('movel'));
  const posPago = items.filter(item => item.path.includes('pospago'));
  const carregamentos = items.filter(item => item.path.includes('carregamentos'));

  if (internet.length) {
    const speed = internet[0].meta.fis.speed;

    internetServiceCharges.push(
      `<p class="title"><strong>INTERNET FIXA:</strong></p>
       <p>Velocidade anunciada = Velocidade máxima = Velocidade normalmente disponível: ${speed.download.max}Mbps download, ${speed.upload.max}Mbps upload. Velocidade mínima = ${speed.download.min}Mbps download, ${speed.upload.min}Mbps upload. <br />Para uma explicação clara e compreensível destes parâmetros, consultar a seção 9 das Condições de Oferta de Serviços, disponível em <a href="https://www.nowo.pt/pdf/condicoes-de-oferta-dos-servicos.pdf" target="_blank">nowo.pt/pdf/condicoes-de-oferta-dos-servicos.pdf</a></p>`
    );
  }

  if (movel.length || posPago.length || carregamentos.length) {
    internetServiceCharges.push(
      '<p class="title"><strong>INTERNET NO TELEMÓVEL:</strong></p>' +
      '<p>3G: Velocidade anunciada = Estimativa velocidade máxima = 16Mbps download, 5Mbps upload<br />4G: Velocidade anunciada = Estimativa velocidade máxima 150Mbps download, 40Mbps upload<br />Para uma explicação clara e compreensível destes parâmetros, consultar a seção 11 das Condições de Oferta de Serviços, disponível em <a href="https://www.nowo.pt/pdf/Condicoes-de-Oferta-dos-Servicos.pdf" target="_blank"> nowo.pt/pdf/Condicoes-de-Oferta-dos-Servicos.pdf</a></p>'
    );
  }

  return internetServiceCharges;
};

export const getTelephoneServiceCharges = (_rootGetters) => {
  const items = _rootGetters['fis/getBaseServices'];
  const telephoneServiceCharges = [];

  const movel = items.filter(item => item.path.includes('movel'));
  const telefone = items.filter(item => item.path.includes('telefone'));
  const posPago = items.filter(item => item.path.includes('pospago'));
  const carregamentos = items.filter(item => item.path.includes('carregamentos'));

  if (telefone.length) {
    telephoneServiceCharges.push(
      '<p class="title"><strong>TELEFONE FIXO:</strong></p>' +
      '<p>Após esgotamento dos plafonds: 4,8 cênt/min em horário económico, 8 cênt/min em horário normal para chamadas rede fixa nacional e 39,7 cênt/min para redes móveis nacionais.</p>'
    );
  }

  if (movel.length || posPago.length) {
    telephoneServiceCharges.push(
      '<p class="title"><strong>TELEFONE MÓVEL:</strong></p>' +
      '<p>Após esgotamento dos plafonds: 17,2 cênt/min ou SMS. Após esgotar os dados o acesso é bloqueado e subscrição de um plano extra de dados é opcional.</p>'
    );
  }

  if (carregamentos.length) {
    telephoneServiceCharges.push(
      '<p><strong>TELEFONE MÓVEL:</strong></p>' +
      '<p>Após esgotamento dos plafonds o acesso é bloqueado.</p>' +
      '<p>Opções de carregamento: <br />  1) 500 Minutos/SMS + 500MB por 7,50€<br />  2) 1000 Minutos/SMS + 1GB por 13,50€<br />  3) 2000 Minutos/SMS + 2GB por 16,00€ <br />  Os plafonds incluídos no plano escolhido são renovados sempre que é efetuado um carregamento e incluem minutos/SMS para a rede fixa e móvel nacional e em roaming no EEE e Reino Unido e Internet no telemóvel em Portugal e em roaming no EEE e Reino Unido. <br />  Os plafonds acumulados podem ser utilizados durante 60 dias, desde que seja efetuado um carregamento a cada 30 dias.<br />  Se o carregamento não for efetuado, deixa de poder realizar comunicações e perde os plafonds não consumidos.<br />  Após 90 dias sem carregamentos o cartão é desativado.</p>');
  }

  return telephoneServiceCharges;
};

export const getTotals = (getters, _rootGetters, fidelization) => {
  const isChargeOption = getters.getBaseServices[0].path.includes('carregamentos');

  if (isChargeOption) {
    return [
      {
        price: '€ 0,00 /mês',
        priceWithoutDiscount: '€ 0,00 /mês',
        discount: '€ 0,00 /mês',
        label: 'Total',
        fidelization
      }
    ];
  }

  const hasPeriodicOffer = _rootGetters['offers/getValidDiscountOffers'].filter(item => item.subject.isPeriodic);
  const totalPrice = [];
  const totalPriceWithoutDiscount = getters.getTotalNonFidelizedPrice;

  let totalBasePrice = getters.getTotalBaseServicesPrice;

  const ddCost = _rootGetters['cart/getActiveItems'].filter(item => item.path.includes('debitodireto')).length ? 0 : 1;
  const feCost = _rootGetters['cart/getActiveItems'].filter(item => item.path.includes('digital')).length ? 0 : 1;

  totalBasePrice += ddCost + feCost;

  let totalLabel = 'Total';

  const additionalsItems = getters.getTotalAdditionalServicesPrice;
  const additionItemsOld = getters.getTotalAdditionalOldServicesPrice;

  // Principal mobile number
  const mobileItems = _rootGetters['cart/getActiveItems'].filter(i => i.path.includes('movel') || i.path.includes('plano'));
  const chosenNumber = mobileItems.length ? mobileItems[mobileItems.length - 1] : null;

  // Principal price
  // eslint-disable-next-line no-nested-ternary
  const chosenPrice = mobileItems.length ? (chosenNumber.price[0].old ? chosenNumber.price[0].old : chosenNumber.price[0].value) : 0;
  const mobileCampaign = _rootGetters['cart/getActiveItems'].filter(i => i.path.includes('gb_15') || i.path.includes('gb_1'));

  // This is for the 15gb campaign if the principal is a 15gb card
  const chosenDiscount = mobileCampaign.filter(i => i.path.includes(chosenNumber.path));
  const chosenMobilePriceWithDiscount = chosenDiscount.length ? chosenDiscount.map(i => i.price[0].old)[0] - chosenDiscount.map(i => i.price[0].value)[0] : 0;

  // check for silent offers ignoring DD and FE discount and taking it from de base value
  const validSilentOffers = _rootGetters['offers/getValidDiscountSilentOffers'].filter(i => !i.description.includes('Débito') && !i.description.includes('Fatura'));
  const validSilentOffersValue = validSilentOffers.length ? validSilentOffers.map(i => i.subject.value).reduce((sum, x) => sum + x) : 0;

  if (hasPeriodicOffer.length && _rootGetters['packages/getActivePackageMeta'].name === 'casa') {
    // FIXO
    // Verify the valid offers to FIXO and exclude the DD, FE and the 5€ fidelization (need to review this offer)
    const fidelizationDiscount = 'Desconto de 5€ durante fidelização';
    const validOffers = _rootGetters['offers/getValidDiscountOffers'].filter(i => i.description !== fidelizationDiscount && !i.description.includes('Débito') && !i.description.includes('Fatura') && !i.description.includes('GB'));
    const validOffersDiscount = validOffers.length ? validOffers.map(i => i.subject.value).reduce((sum, x) => sum + x) : 0;

    const mobile15Gb = _rootGetters['cart/getActiveItems'].filter(i => i.path.includes('gb_15'));

    // Has 15gb fidelization discount (NET250 + TV FAMILIA + TLF + 15GB MOVEL)
    const fidelization15gbCampaignDiscount = _rootGetters['offers/getValidDiscountOffers'].filter(i => i.description === fidelizationDiscount);

    // Chosen Mobile
    // eslint-disable-next-line no-nested-ternary
    const fixoChosenMobilePriceWithDiscount = fidelization15gbCampaignDiscount.length ? mobile15Gb[0].price[0].value : (chosenNumber !== null ? chosenNumber.price[0].value : 0);
    let fixoChosenMobilePriceOld = 0;
    if (fidelization15gbCampaignDiscount.length) {
      fixoChosenMobilePriceOld = mobile15Gb[0].price[0].old;
    } else {
      // eslint-disable-next-line no-nested-ternary
      fixoChosenMobilePriceOld = mobileCampaign.length && mobileCampaign ? chosenNumber.price[0].old : (chosenNumber !== null ? chosenNumber.price[0].value : 0);
    }
    // additionals
    const mobile15GbPrice = mobile15Gb.length ? mobile15Gb[0].price[0].value : 0;
    const additionalServicesPrice = fidelization15gbCampaignDiscount.length && additionalsItems.length ? (additionalsItems - chosenPrice) + mobile15GbPrice : additionalsItems;

    const totalBasePriceWithoutMobile = chosenNumber !== null ? totalBasePrice - chosenNumber.price[0].value : totalBasePrice;
    const mobileValidDiscount = mobileCampaign.length ? (fixoChosenMobilePriceOld - fixoChosenMobilePriceWithDiscount) : 0;

    const periodicPrice = (((totalBasePriceWithoutMobile - validOffersDiscount) + fixoChosenMobilePriceWithDiscount) - mobileValidDiscount) + additionalServicesPrice;
    const totalNonFidPrice = fidelization15gbCampaignDiscount.length ? totalPriceWithoutDiscount - (chosenNumber.price[1].value - mobile15Gb[0].price[1].value) : totalPriceWithoutDiscount;

    totalPrice.push({
      price: `${CURRENCY} ${periodicPrice.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      priceWithoutDiscount: `${CURRENCY} ${totalNonFidPrice.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      discount: `${CURRENCY} ${(totalNonFidPrice - periodicPrice).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      label: 'Total entre 1º e 12º mês',
      fidelization
    });

    totalLabel = totalLabel.concat(' entre 13º e 24º mês');

    const priceWithoutPeriodicOffer = fidelization15gbCampaignDiscount.length ? ((getters.getTotalBaseServicesPrice - validSilentOffersValue) + additionItemsOld) - (chosenNumber.price[1].value - mobile15Gb[0].price[1].value) : (getters.getTotalBaseServicesPrice - validSilentOffersValue) + additionItemsOld;

    totalPrice.push({
      price: `${CURRENCY} ${(priceWithoutPeriodicOffer).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      priceWithoutDiscount: `${CURRENCY} ${totalNonFidPrice.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      discount: `${CURRENCY} ${(totalNonFidPrice - priceWithoutPeriodicOffer).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      label: totalLabel,
      fidelization
    });
  }

  const additionalOldPrice = getters.getTotalAdditionalOldServicesPrice;
  if (hasPeriodicOffer.length && _rootGetters['packages/getActivePackageMeta'].name !== 'casa') {
    totalPrice.push({
      price: `${CURRENCY} ${(totalBasePrice + additionalsItems).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      priceWithoutDiscount: `${CURRENCY} ${totalPriceWithoutDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      discount: `${CURRENCY} ${(totalPriceWithoutDiscount - (totalBasePrice + additionalsItems)).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      label: 'Total entre 1º e 12º mês',
      fidelization
    });

    totalLabel = totalLabel.concat(' entre 13º e 24º mês');

    totalPrice.push({
      price: `${CURRENCY} ${(chosenPrice + additionalOldPrice).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      priceWithoutDiscount: `${CURRENCY} ${totalPriceWithoutDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      discount: `${CURRENCY} ${(totalPriceWithoutDiscount - (chosenPrice + additionalOldPrice)).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
      label: totalLabel,
      fidelization
    });
  }

  if (!hasPeriodicOffer.length) {
    if (fidelization === '1 mês') {
      totalPrice.push({
        price: `${CURRENCY} ${totalPriceWithoutDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        priceWithoutDiscount: `${CURRENCY} ${totalPriceWithoutDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        discount: `${CURRENCY} ${(totalPriceWithoutDiscount - totalPriceWithoutDiscount).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        label: totalLabel,
        fidelization
      });
    } else {
      const fidelizationFlashDescription = 'durante fidelização';
      const fidelizationFlashDiscount = _rootGetters['offers/getValidDiscountOffers'].filter(i => i.description.includes(fidelizationFlashDescription));
      const fidelizationFlashDiscountValue = fidelizationFlashDiscount.length ? fidelizationFlashDiscount.map(i => i.subject.value).reduce((sum, x) => sum + x) : 0;
      const fixo = _rootGetters['packages/getActivePackageMeta'].name === 'casa';

      /* Need to add this condition because when its 24 months but has no offer in 15gb mobile campaign. Removed this when campaign end */
      const basePrice = mobileItems.length && mobileCampaign.length && !fixo ? (totalBasePrice - chosenMobilePriceWithDiscount) + chosenPrice : totalBasePrice;
      const total = fixo ? (basePrice + additionalsItems) - fidelizationFlashDiscountValue : chosenPrice + additionalOldPrice + ddCost + feCost;

      totalPrice.push({
        price: `${CURRENCY} ${(total).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        priceWithoutDiscount: `${CURRENCY} ${totalPriceWithoutDiscount.toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        discount: `${CURRENCY} ${(totalPriceWithoutDiscount - total).toFixed(2).replace('.', ',')} ${RECURRENCE}`,
        label: totalLabel,
        fidelization
      });
    }
  }
  return totalPrice;
};

export const generateNonRecurringTotal = (getters, _rootGetters) => {
  const nonRecurringTotal = {
    items: [],
    total: {
      label: 'Total',
      price: 0,
      discount: 0,
      priceWithoutDiscount: 0
    }
  };
  const items = _rootGetters['packages/getActivePackageConfig'].totalsExtraItems;

  items.forEach((item) => {
    if ((!item.requires || (item.requires && _rootGetters['cart/isPathActive'](item.requires))) && (item.showNonRecurringPriceFIS && item.showNonRecurringPriceFIS.includes(_rootGetters['simulation/getPackage']))) {
      if (item.namespace) {
        const price = _rootGetters['cart/activeItemsInNamespacePrice'](item.namespace);
        const priceWithoutDiscount = item.namespace.includes('permanencia') ?
          _rootGetters['cart/getPathPrice']('permanencia.components.months_1').value :
          _rootGetters['cart/activeItemsInNamespacePrice'](item.namespace);
        if (priceWithoutDiscount) {
          nonRecurringTotal.items.push(
            {
              label: item.name,
              price: `${CURRENCY} ${price.toFixed(2).replace('.', ',')}`,
              discount: `${CURRENCY} ${(priceWithoutDiscount - price).toFixed(2).replace('.', ',')}`,
              priceWithoutDiscount: `${CURRENCY} ${priceWithoutDiscount.toFixed(2).replace('.', ',')}`
            }
          );
          nonRecurringTotal.total.price += price;
          nonRecurringTotal.total.priceWithoutDiscount += priceWithoutDiscount;
        }
      } else if (item.path && item.showNonRecurringPriceFIS.includes(_rootGetters['simulation/getPackage'])) {
        const price = _rootGetters['cart/getPathPrice'](item.path).value;
        const priceWithoutDiscount = _rootGetters['cart/getPathNonFidelizedPrice'](item.path).value;
        if (priceWithoutDiscount) {
          nonRecurringTotal.items.push(
            {
              label: item.name,
              price: `${CURRENCY} ${price.toFixed(2).replace('.', ',')}`,
              discount: `${CURRENCY} ${(priceWithoutDiscount - price).toFixed(2).replace('.', ',')}`,
              priceWithoutDiscount: `${CURRENCY} ${priceWithoutDiscount.toFixed(2).replace('.', ',')}`
            }
          );
          nonRecurringTotal.total.price += price;
          nonRecurringTotal.total.priceWithoutDiscount += priceWithoutDiscount;
        }
      }
    }
  });


  nonRecurringTotal.total.discount = `${CURRENCY} ${(nonRecurringTotal.total.priceWithoutDiscount - nonRecurringTotal.total.price).toFixed(2).replace('.', ',')}`;
  nonRecurringTotal.total.price = `${CURRENCY} ${nonRecurringTotal.total.price.toFixed(2).replace('.', ',')}`;
  nonRecurringTotal.total.priceWithoutDiscount = `${CURRENCY} ${nonRecurringTotal.total.priceWithoutDiscount.toFixed(2).replace('.', ',')}`;

  return nonRecurringTotal;
};

export const getFidelizationValue = (value) => {
  if (!value) {
    return '1 mês';
  }
  return `${value} meses`;
};

export const generateContent = (state, getters, rootState, rootGetters) => (name, email, taxId) => {
  const address = rootGetters['addresses/getSelectedAddressFormatted'] || null;

  const fidelization = `${rootGetters['cart/namespaceExists']('permanencia') ? getFidelizationValue(rootGetters['cart/activeItemsInNamespace']('permanencia')[0].meta.code) : '1 mês'}`;

  const isChargesOption = getters.getBaseServices[0].path.includes('carregamentos');

  const isMsaOption = getters.getBaseServices[0].path.includes('pospago');

  let installation = rootGetters['cart/namespaceExists']('permanencia') ? rootGetters['cart/activeItemsInNamespacePrice']('permanencia') : 0;

  installation = rootGetters['cart/isPathActive']('numero.components.new') ? installation + rootGetters['cart/getPathPrice']('numero.components.new').value : installation;
  installation = rootGetters['cart/isPathActive']('numero.components.keep') ? installation + rootGetters['cart/getPathPrice']('numero.components.keep').value : installation;

  if (rootGetters['simulation/getPackage'].startsWith('iptv')) {
    installation += rootGetters['cart/getPathPrice']('tv.children.premium.components.not_categorized.components.box').value;
  }

  const generatedAdditionalItems = generateAdditionalItems(getters, rootGetters);

  const generatedServiceName = generateServiceName(rootGetters);

  // Get included Services Descriptions
  const includedItems = generateIncludedItems(rootGetters);

  const additionalDescriptions = getAdditionalServicesDescription(rootGetters);

  const internetServiceCharges = getInternetServiceCharges(rootGetters);

  const telephoneServiceCharges = getTelephoneServiceCharges(rootGetters);

  const totals = getTotals(getters, rootGetters, fidelization);

  const NIF = taxId === '' ? 'N/A' : taxId;

  const isBillingAddress = rootGetters['simulation/getPackage'].includes('movel.');

  const structure = {
    simulationId: rootGetters['simulation/getId'],
    serviceName: generatedServiceName,
    isCharges: isChargesOption,
    isMsa: isMsaOption,
    fidelization,
    user: {
      name,
      email,
      address,
      NIF,
      isBillingAddress
    },
    services: {
      included: {
        totals: generateIncludedTotal(getters, rootGetters),
        installation: installation.toFixed(2).replace('.', ',')
      },
      additional: generatedAdditionalItems,
      additionalDescriptions,
      internetServiceCharges,
      telephoneServiceCharges,
      totals,
      nonRecurringTotal: generateNonRecurringTotal(getters, rootGetters)
    },
    offers: {
      fidelization: getters.generateFidelizedOffers,
      nonFidelization: getters.generateNonFidelizedOffers
    }
  };

  Object.assign(structure.services.included, includedItems);

  return structure;
};

export const generateFidelizedOffers = (state, getters, rootState, rootGetters) => {
  const content = [];
  let total = 0;
  const fidelization = rootGetters['cart/namespaceExists']('permanencia') ? rootGetters['cart/activeItemsInNamespace']('permanencia')[0].meta.code : 0;
  const installation = rootGetters['cart/namespaceExists']('permanencia') ? rootGetters['cart/activeItemsInNamespacePrice']('permanencia') : 0;
  const maxInstallation = rootGetters['cart/namespaceExists']('permanencia') ? rootGetters['cart/getPathPrice']('permanencia.components.months_1').value : 0;
  const totalBasePrice = getters.getTotalBaseServicesPrice;
  const totalBaseNonFidelizedPrice = getters.getTotalNonFidelizedBaseServicesPrice;
  const totalAdditionalNonFidelizedPrice = getters.getTotalAdditionalNonFidelizedServicesPrice;
  const hasPeriodicOffer = rootGetters['offers/getValidDiscountOffers'].filter(item => item.subject.isPeriodic);
  const mobileCampaign = rootGetters['cart/getActiveItems'].filter(i => i.path.includes('gb_15') || i.path.includes('gb_1'));
  // need to FIXO discounts calculus
  const mappedDiscountOffers = hasPeriodicOffer.map(v => v.subject.value);
  const hasPeriodicOfferValue = hasPeriodicOffer.length ? mappedDiscountOffers.reduce((sum, x) => sum + x) : 0;
  const hasExtraOffer = rootGetters['offers/getValidDiscountSilentOffers'].filter(offer => offer.description.includes('fidelização'));
  const hasExtraOfferVal = hasExtraOffer.length ? hasExtraOffer.map(item => item.subject.value) : 0;
  const hasExtraOfferPrice = hasExtraOffer.length ? hasExtraOfferVal.reduce((sum, x) => sum + x) : 0;
  const mobileItems = rootGetters['cart/getActiveItems'].filter(i => i.path.includes('movel') || i.path.includes('plano'));
  const chosenMobile = mobileItems[mobileItems.length - 1];
  // primary mobile with discount campaign (using it in MSA)
  const chosenDiscount = mobileCampaign.filter(i => i.path.includes(chosenMobile.path));
  const chosenDiscountValue = chosenDiscount.length ? chosenDiscount.map(i => i.price[0].old)[0] - chosenDiscount.map(i => i.price[0].value)[0] : 0;
  const validOffer = rootGetters['offers/getValidDiscountOffers'].filter(item => !item.subject.isPeriodic && !item.description.includes('Fatura') && !item.description.includes('Débito') && !item.description.includes('fidelização'));
  const validOffersValue = validOffer.length ? validOffer.map(v => v.subject.value) : 0;
  const allNonPeriodicOffers = validOffer.length ? validOffersValue.reduce((sum, x) => sum + x) : 0;

  // Need the mobile additionals to added to the periodic discounts in FIXO
  const mobileCampaignFIXO = getters.getTotalAdditionalOldServicesPrice - getters.getTotalAdditionalServicesPrice;

  // Check type of package
  const packageName = rootGetters['packages/getActivePackageMeta'].name;

  // IPTV AND CARREGAMENTOS -> RETURN N/A
  if (packageName.toLowerCase() === 'carregamentos' || packageName.toLowerCase() === 'iptv') {
    return {
      content: [
        {
          title: NOT_AVAILABLE,
          value: `${CURRENCY} 0,00`
        }
      ],
      total: '0,00'
    };
  }

  // INSTALLATION
  if (installation < maxInstallation) {
    total += maxInstallation - installation;
    content.push({
      title: 'Desconto incluído na Instalação',
      value: `€${(maxInstallation - installation).toFixed(2).replace('.', ',')}`
    });
  } else {
    content.push({
      title: 'Desconto incluído na Instalação',
      value: '€ 0,00'
    });
  }

  let faturaDiscount = 0;
  let faturaDiscountText = '';

  if (rootGetters['cart/isPathActive']('fatura.components.digital_debitodireto')) {
    let movelDiscount = 0;
    if (packageName.toLowerCase() === 'pospago' || packageName.toLowerCase() === 'movel') movelDiscount = !rootGetters['cart/isPathActive']('permanencia.components.months_1') ? 2 : 0;
    faturaDiscount = packageName.toLowerCase() === 'casa' && rootGetters['cart/isPathActive']('permanencia.components.months_24') ? 2 : movelDiscount;
    faturaDiscountText = faturaDiscountText.concat(' e Débito Direto');
  }

  if (rootGetters['cart/isPathActive']('fatura.components.digital')) {
    let movelDiscount = 0;
    if (packageName.toLowerCase() === 'pospago' || packageName.toLowerCase() === 'movel') movelDiscount = !rootGetters['cart/isPathActive']('permanencia.components.months_1') ? 1 : 0;
    faturaDiscount = packageName.toLowerCase() === 'casa' && rootGetters['cart/isPathActive']('permanencia.components.months_24') ? 1 : movelDiscount;
  }

  const totalFidelizationPriceDiff = totalBaseNonFidelizedPrice - totalBasePrice;

  const feCost = rootGetters['cart/isPathActive']('fatura.components.analog') ? 2 : 0;
  const deCost = rootGetters['cart/isPathActive']('fatura.components.digital') ? 1 : 0;
  const ddCost = rootGetters['cart/isPathActive']('fatura.components.analog_debitodireto') ? 1 : 0;
  const losingDiscount = deCost + feCost + ddCost;

  // Serviços e Equipamentos
  if (totalFidelizationPriceDiff > 0) {
    if (packageName.toLowerCase() === 'pospago') {
      const extraValue = chosenDiscount.length ? chosenDiscountValue : 0;
      total += (totalFidelizationPriceDiff - faturaDiscount - losingDiscount - extraValue) * fidelization;
      content.push({
        title: 'Desconto incluído em Serviços e equipamentos',
        value: `€${(totalFidelizationPriceDiff - faturaDiscount - losingDiscount - extraValue).toFixed(2).replace('.', ',')} durante ${fidelization} meses = €${((totalFidelizationPriceDiff - faturaDiscount - losingDiscount - extraValue) * fidelization).toFixed(2).replace('.', ',')}`
      });
    }

    if (packageName.toLowerCase() === 'casa') {
      const discountFid = (totalFidelizationPriceDiff - faturaDiscount - losingDiscount) + hasExtraOfferPrice;
      total += discountFid * fidelization;

      content.push({
        title: 'Desconto incluído em Serviços e equipamentos',
        value: `€${(discountFid).toFixed(2).replace('.', ',')} durante ${fidelization} meses = €${(discountFid * fidelization).toFixed(2).replace('.', ',')}`
      });
    }
  } else {
    content.push({
      title: 'Desconto incluído em Serviços e equipamentos',
      value: '€ 0,00'
    });
  }

  // Serviços e Equipamentos com FE e/ou DD
  if (faturaDiscount) {
    total += (faturaDiscount * fidelization);
    content.push({
      title: `Desconto incluído em Serviços e equipamentos, mediante ativação da Fatura Eletrónica${faturaDiscountText}`,
      value: `€${faturaDiscount.toFixed(2).replace('.', ',')} durante ${fidelization} meses = €${(faturaDiscount * fidelization).toFixed(2).replace('.', ',')}`
    });
  } else {
    content.push({
      title: 'Desconto incluído em Serviços e equipamentos, mediante ativação da Fatura Eletrónica e Débito Direto',
      value: '€ 0,00'
    });
  }

  if (hasPeriodicOffer.length) {
    if (rootGetters['packages/getActivePackageMeta'].name !== 'casa') {
      const campaignValue = getters.getTotalMobileBaseServicesPrice - getters.getTotalPrice;
      total += campaignValue * (fidelization / 2);

      content.push({
        title: 'Desconto incluído em Serviços e equipamentos do 1º ao 12º mês, mediante ativação da Fatura Eletrónica e Débito Direto',
        value: `€${(campaignValue).toFixed(2).replace('.', ',')} durante ${fidelization / 2} meses = €${(campaignValue * (fidelization / 2)).toFixed(2).replace('.', ',')}`
      });
    }

    if (rootGetters['packages/getActivePackageMeta'].name === 'casa') {
      const totalOffer = mobileCampaign.length && chosenMobile.path.includes('gb_15') ? (hasPeriodicOfferValue - chosenDiscountValue) + mobileCampaignFIXO : hasPeriodicOfferValue + mobileCampaignFIXO;

      total += totalOffer * (fidelization / 2);

      content.push({
        title: 'Desconto incluído em Serviços e equipamentos do 1º ao 12º mês, mediante ativação da Fatura Eletrónica e Débito Direto',
        value: `€${(totalOffer).toFixed(2).replace('.', ',')} durante ${fidelization / 2} meses = €${(totalOffer * (fidelization / 2)).toFixed(2).replace('.', ',')}`
      });
    }
  }

  if (((totalAdditionalNonFidelizedPrice - getters.getTotalAdditionalServicesPrice) + allNonPeriodicOffers) > 0) {
    let additionalServicesValue = getters.getTotalAdditionalServicesPrice;

    // Get only the fidelized discount from moveis adicionais and only if !casa
    if (rootGetters['packages/getActivePackageMeta'].name !== 'casa') {
      rootGetters['cart/activeItemsInNamespace']('plano').forEach((item) => {
        let fidelizationDiscount = 0;

        if (rootGetters['cart/isPathActive']('permanencia.components.months_24')) fidelizationDiscount = 4;
        else if (!rootGetters['cart/isPathActive']('permanencia.components.months_1')) fidelizationDiscount = 1;
        additionalServicesValue -= item.path === chosenMobile.path ? rootGetters['cart/getPathPrice'](item.path).value * (item.quantity - 1) : rootGetters['cart/getPathPrice'](item.path).value * item.quantity;
        const price = item.path === chosenMobile.path ? (rootGetters['cart/getPathNonFidelizedPrice'](item.path).value - fidelizationDiscount) * (item.quantity - 1) : (rootGetters['cart/getPathNonFidelizedPrice'](item.path).value - fidelizationDiscount) * item.quantity;
        additionalServicesValue += price;
      });
    }

    total += mobileItems.length ? (((totalAdditionalNonFidelizedPrice - getters.getTotalAdditionalOldServicesPrice) + allNonPeriodicOffers) * fidelization) : (((totalAdditionalNonFidelizedPrice - additionalServicesValue) + allNonPeriodicOffers) * fidelization);
    if (rootGetters['packages/getActivePackageMeta'].name === 'casa') {
      if (mobileCampaign.length) {
        content.push({
          title: 'Desconto incluído em Serviços e equipamentos adicionais',
          value: `€${((totalAdditionalNonFidelizedPrice - getters.getTotalAdditionalOldServicesPrice) + allNonPeriodicOffers).toFixed(2).replace('.', ',')} durante ${fidelization} meses = €${(((totalAdditionalNonFidelizedPrice - getters.getTotalAdditionalOldServicesPrice) + allNonPeriodicOffers) * fidelization).toFixed(2).replace('.', ',')}`
        });
      } else {
        content.push({
          title: 'Desconto incluído em Serviços e equipamentos adicionais',
          value: `€${((totalAdditionalNonFidelizedPrice - additionalServicesValue) + allNonPeriodicOffers).toFixed(2).replace('.', ',')} durante ${fidelization} meses = €${(((totalAdditionalNonFidelizedPrice - additionalServicesValue) + allNonPeriodicOffers) * fidelization).toFixed(2).replace('.', ',')}`
        });
      }
    }

    // Get only the fidelized discount from moveis adicionais and only if !casa
    if (rootGetters['packages/getActivePackageMeta'].name !== 'casa') {
      if (mobileCampaign.length) {
        content.push({
          title: 'Desconto incluído em Serviços e equipamentos adicionais',
          value: `€${(totalAdditionalNonFidelizedPrice - getters.getTotalAdditionalOldServicesPrice).toFixed(2).replace('.', ',')} durante ${fidelization} meses = €${((totalAdditionalNonFidelizedPrice - getters.getTotalAdditionalOldServicesPrice) * fidelization).toFixed(2).replace('.', ',')}`
        });
      } else {
        let movelAdicionaisDiscount = 0;
        rootGetters['cart/activeItemsInNamespace']('plano').forEach((item) => {
          movelAdicionaisDiscount += item.path === chosenMobile.path ? rootGetters['cart/getPathPrice'](item.path).value * (item.quantity - 1) : rootGetters['cart/getPathPrice'](item.path).value * item.quantity;
        });
        content.push({
          title: 'Desconto incluído em Serviços e equipamentos adicionais',
          value: `€${(totalAdditionalNonFidelizedPrice - movelAdicionaisDiscount).toFixed(2).replace('.', ',')} durante ${fidelization} meses = €${((totalAdditionalNonFidelizedPrice - movelAdicionaisDiscount) * fidelization).toFixed(2).replace('.', ',')}`
        });
      }
    }
  } else {
    content.push({
      title: 'Desconto incluído em Serviços e equipamentos adicionais',
      value: '€ 0,00'
    });
  }

  const mensalityOffers = rootGetters['offers/getValidExternalOffers'].find(offer => offer.subject.category === 'mensality');
  const mensalityOffersQuantity = (mensalityOffers && mensalityOffers.subject.quantity) || 0;

  if (mensalityOffersQuantity) {
    const extraMobileCards = rootGetters['cart/namespaceExists']('movel_adicionais') ? rootGetters['cart/activeItemsInNamespacePrice']('movel_adicionais') : 0;

    total += mensalityOffersQuantity * (totalBasePrice + extraMobileCards);
    content.push({
      title: 'Oferta de Mensalidades',
      value: `${mensalityOffersQuantity} Mensalidade${mensalityOffersQuantity > 1 ? 's' : ''} = €${(mensalityOffersQuantity * (totalBasePrice + extraMobileCards)).toFixed(2).replace('.', ',')}`
    });
  } else {
    content.push({
      title: 'Oferta de Mensalidades',
      value: '€ 0,00'
    });
  }

  if (rootGetters['packages/getActivePackageMeta'].name === 'casa') {
    const channelsOffers = rootGetters['offers/getValidInternalOffers'].find(offer => offer.subject.category === 'channels');
    const channelsOffersQuantity = (channelsOffers && channelsOffers.subject.quantity) || 0;

    if (channelsOffersQuantity) {
      // TODO
      // Oferta de € durante x meses = €
      total += channelsOffersQuantity * getters.getTotalPrice;
    } else {
      content.push({
        title: 'Oferta de Pack de canais',
        value: '€ 0,00'
      });
    }
  }

  const landlinePortPath = 'telefone.extra.portabilidade';
  const mobilePortPath = 'movel.extra.portabilidade';
  const mobilePlanPortPath = 'numero.extra.portabilidade';
  const isLandlinePortActive = rootGetters['cart/isPathActive'](landlinePortPath);
  const isMobilePortActive = rootGetters['cart/isPathActive'](mobilePortPath);
  const isMobilePlanPortActive = rootGetters['cart/isPathActive'](mobilePlanPortPath);

  if (isLandlinePortActive || isMobilePortActive || isMobilePlanPortActive) {
    let totalPorts = 0;
    let totalPortValue = 0;

    if (isLandlinePortActive && rootGetters['cart/getPathNonFidelizedPrice'](landlinePortPath).value > rootGetters['cart/getPathPrice'](landlinePortPath).value) {
      totalPorts += 1;
      totalPortValue += rootGetters['cart/getPathNonFidelizedPrice'](landlinePortPath).value - rootGetters['cart/getPathPrice'](landlinePortPath).value;
    }

    if (isMobilePortActive && rootGetters['cart/getPathNonFidelizedPrice'](mobilePortPath).value > rootGetters['cart/getPathPrice'](mobilePortPath).value) {
      totalPorts += 1;
      totalPortValue += rootGetters['cart/getPathNonFidelizedPrice'](mobilePortPath).value - rootGetters['cart/getPathPrice'](mobilePortPath).value;
    }

    if (isMobilePlanPortActive && rootGetters['cart/getPathNonFidelizedPrice'](mobilePlanPortPath).value > rootGetters['cart/getPathPrice'](mobilePlanPortPath).value) {
      totalPorts += 1;
      totalPortValue += rootGetters['cart/getPathNonFidelizedPrice'](mobilePlanPortPath).value - rootGetters['cart/getPathPrice'](mobilePlanPortPath).value;
    }

    if (totalPorts) {
      total += totalPortValue;
      content.push({
        title: 'Oferta de Portabilidades',
        value: `${totalPorts} Portabilidade${totalPorts > 1 ? 's' : ''} = €${totalPortValue.toFixed(2).replace('.', ',')}`
      });
    }
  }

  total = total.toFixed(2).replace('.', ',');

  return {
    total,
    content
  };
};

export const getAdditionalServices = (state, getters, rootState, rootGetters) => {
  const additionItems = rootGetters['cart/getActiveItems'];
  const activeMobileItem = rootGetters['cart/getActiveItems'].filter(i => i.path.includes('movel') || i.path.includes('plano'));
  const chosenNumber = activeMobileItem[activeMobileItem.length - 1];
  const packageName = rootGetters['packages/getActivePackageMeta'].name;

  // Has 15gb fidelization discount (NET250 + TV FAMILIA + TLF + 15GB MOVEL)
  const fidelizationDiscount = 'Desconto de 5€ durante fidelização';
  const fidelization15gbCampaignDiscount = rootGetters['offers/getValidDiscountOffers'].filter(i => i.description === fidelizationDiscount);

  const additionalServices = [];

  additionItems.forEach((i) => {
    if (packageName.toLowerCase() === 'pospago') {
      if (i.meta.fis && i.meta.fis.type === 'additional') {
        additionalServices.push(i);
      }
      if (activeMobileItem.length && i.path.includes('pospago') && !i.path.includes(chosenNumber.path)) {
        additionalServices.push(i);
      }
      if (activeMobileItem.length && i.path === chosenNumber.path && chosenNumber.quantity > 1) {
        additionalServices.push(i);
      }
    }
    if (packageName.toLowerCase() === 'casa') {
      if (i.meta.fis && i.meta.fis.type === 'additional') {
        additionalServices.push(i);
      }
      if (!fidelization15gbCampaignDiscount.length) {
        if (activeMobileItem.length && i.path.includes('movel') && !i.path.includes(chosenNumber.path)) {
          additionalServices.push(i);
        }
        if (activeMobileItem.length && i.path === chosenNumber.path && chosenNumber.quantity > 1) {
          additionalServices.push(i);
        }
      } else {
        // this is used to change the chosen to additional when the 15gb campaign is on at fixo. Need to be removed in the end of campaign
        if (activeMobileItem.length && i.path.includes('movel') && !i.path.includes(chosenNumber.path) && !i.path.includes('gb_15')) {
          additionalServices.push(i);
        }
        if (activeMobileItem.length && i.path.includes('movel') && !i.path.includes(chosenNumber.path) && (i.path.includes('gb_15') && i.quantity > 1)) {
          additionalServices.push(i);
        }
        if (activeMobileItem.length && i.path === chosenNumber.path && (i.path.includes('gb_15') && i.quantity > 1)) {
          additionalServices.push(i);
        }
        if (activeMobileItem.length && i.path === chosenNumber.path && !chosenNumber.path.includes('gb_15')) {
          additionalServices.push(i);
        }
      }
    }
    if (packageName.toLowerCase() === 'carregamentos') {
      if (i.meta.fis && i.meta.fis.type === 'additional') {
        additionalServices.push(i);
      }
    }
  });

  return additionalServices;
};

export const getHiddenAdditionalServices = (state, getters, rootState, rootGetters) => rootGetters['cart/getActiveItems'].filter(i => i.meta.fis && i.meta.fis.type === 'hidden');

export const getBaseServices = (state, getters, rootState, rootGetters) => rootGetters['cart/getActiveItems'].filter(i => i.meta.fis && i.meta.fis.type === 'base');

export const getAdditionalMobileServices = (state, getters, rootState, rootGetters) => rootGetters['cart/getActiveItems'].filter(i => i.meta.fis && i.meta.fis.type === 'additional' && i.meta.fis.family === 'movel_adicionais');

export const getTotalHiddenAdditionalServicesPrice = (state, getters, rootState, rootGetters) => {
  if (!rootState.cart.content) {
    return 0;
  }

  let total = 0;

  getters.getHiddenAdditionalServices.map((item) => {
    if (rootGetters['offers/isPathAnOffer'](item.path)) {
      return false;
    }

    const activePrice = rootGetters['cart/getPathPrice'](item.path);
    const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
    const value = item.quantity * (activePrice.value + basePrice);

    total += value;

    return true;
  });

  return total;
};

export const getTotalAdditionalOldServicesPrice = (state, getters, rootState, rootGetters) => {
  if (!rootState.cart.content) {
    return 0;
  }

  let total = 0;

  const filteredAdditionalItems = getters.getAdditionalServices.filter(item => !item.config.isUnaccountable);
  const filteredItems = getters.getBaseServices.filter(item => !item.config.isUnaccountable);
  const mobileBaseItems = filteredItems.filter(i => i.path.includes('movel') || i.path.includes('plano'));

  filteredAdditionalItems.map((item) => {
    if (rootGetters['offers/isPathAnOffer'](item.path)) {
      return false;
    }

    if (mobileBaseItems.length) {
      const mobileBaseChosen = mobileBaseItems[mobileBaseItems.length - 1];
      if (item.path === mobileBaseChosen.path && mobileBaseChosen.quantity > 1) {
        const activePrice = rootGetters['cart/getPathPrice'](item.path);
        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
        const value = (item.quantity - 1) * (activePrice.old ? activePrice.old : (activePrice.value + basePrice));

        total += value;
      } else {
        const activePrice = rootGetters['cart/getPathPrice'](item.path);
        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
        const value = item.quantity * (activePrice.old ? activePrice.old : (activePrice.value + basePrice));

        total += value;
      }
    } else {
      const activePrice = rootGetters['cart/getPathPrice'](item.path);
      const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
      const value = item.quantity * (activePrice.old ? activePrice.old : (activePrice.value + basePrice));

      total += value;
    }

    return true;
  });

  return total;
};

export const getTotalAdditionalServicesPrice = (state, getters, rootState, rootGetters) => {
  if (!rootState.cart.content) {
    return 0;
  }

  let total = 0;
  const filteredAdditionalItems = getters.getAdditionalServices.filter(item => !item.config.isUnaccountable);
  const filteredItems = getters.getBaseServices.filter(item => !item.config.isUnaccountable);
  const mobileBaseItems = filteredItems.filter(i => i.path.includes('movel') || i.path.includes('plano'));

  filteredAdditionalItems.map((item) => {
    if (rootGetters['offers/isPathAnOffer'](item.path)) {
      return false;
    }
    if (mobileBaseItems.length) {
      const mobileBaseChosen = mobileBaseItems[mobileBaseItems.length - 1];
      if (item.path === mobileBaseChosen.path && mobileBaseChosen.quantity > 1) {
        const activePrice = rootGetters['cart/getPathPrice'](item.path);
        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
        const value = (item.quantity - 1) * (activePrice.value + basePrice);

        total += value;
      } else {
        const activePrice = rootGetters['cart/getPathPrice'](item.path);
        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
        const value = (item.quantity * (activePrice.value + basePrice));

        total += value;
      }
    } else {
      const activePrice = rootGetters['cart/getPathPrice'](item.path);
      const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
      const value = (item.quantity * (activePrice.value + basePrice));

      total += value;
    }

    return true;
  });

  return total;
};

export const getTotalAdditionalServicesPriceWithPeriodicOffer = (state, getters, rootState, rootGetters) => {
  if (!rootState.cart.content) {
    return 0;
  }

  let total = 0;
  const hasPeriodicPrice = rootGetters['offers/getValidExternalOffers'].filter(item => item.subject.isPeriodic);
  const filteredItems = getters.getAdditionalServices.filter(item => !item.config.isUnaccountable);

  filteredItems.map((item) => {
    if (rootGetters['offers/isPathAnOffer'](item.path)) {
      return false;
    }

    const activePrice = rootGetters['cart/getPathPrice'](item.path);

    const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
    const value = item.quantity * ((hasPeriodicPrice.length && item.path.includes('movel_adicionais') ? activePrice.value / 2 : activePrice.value) + basePrice);

    total += value;

    return true;
  });

  return total;
};

export const getTotalAdditionalNonFidelizedServicesPrice = (state, getters, rootState, rootGetters) => {
  if (!rootState.cart.content) {
    return 0;
  }

  let total = 0;

  const filteredAdditionalItems = getters.getAdditionalServices.filter(item => !item.config.isUnaccountable);
  const filteredItems = getters.getBaseServices.filter(item => !item.config.isUnaccountable);
  const mobileBaseItems = filteredItems.filter(i => i.path.includes('movel') || i.path.includes('plano'));

  filteredAdditionalItems.map((item) => {
    if (rootGetters['offers/isPathAnOffer'](item.path)) {
      return false;
    }
    if (mobileBaseItems.length) {
      const mobileBaseChosen = mobileBaseItems[mobileBaseItems.length - 1];

      if (item.path === mobileBaseChosen.path && mobileBaseChosen.quantity > 1) {
        const activePrice = rootGetters['cart/getPathNonFidelizedPrice'](item.path);
        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
        const value = (item.quantity - 1) * (activePrice.value + basePrice);

        total += value;
      } else {
        const activePrice = rootGetters['cart/getPathNonFidelizedPrice'](item.path);

        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;

        const value = item.quantity * (activePrice.value + basePrice);

        total += value;
      }
    } else {
      const activePrice = rootGetters['cart/getPathNonFidelizedPrice'](item.path);
      const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
      const value = item.quantity * (activePrice.value + basePrice);

      total += value;
    }
    return true;
  });

  return total;
};

export const getTotalBaseServicesPrice = (state, getters, rootState, rootGetters) => {
  if (!rootState.cart.content) {
    return 0;
  }

  let total = 0;

  const filteredItems = getters.getBaseServices.filter(item => !item.config.isUnaccountable);
  const mobileItems = filteredItems.filter(i => i.path.includes('movel') || i.path.includes('plano'));
  const mobileBaseChosen = mobileItems[mobileItems.length - 1];
  const packageName = rootGetters['packages/getActivePackageMeta'].name;

  filteredItems.map((item) => {
    if (rootGetters['offers/isPathAnOffer'](item.path)) {
      return false;
    }

    if (packageName.toLowerCase() === 'pospago') {
      if (item.path !== mobileBaseChosen.path) {
        return false;
      }

      if (item.path === mobileBaseChosen.path) {
        const activePrice = rootGetters['cart/getPathPrice'](item.path);
        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
        const value = activePrice.value + basePrice;

        total += value;
      }
      return true;
    }

    if (packageName.toLowerCase() === 'casa') {
      if (mobileItems.length && item.path === mobileBaseChosen.path) {
        const activePrice = rootGetters['cart/getPathPrice'](item.path);
        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
        const value = activePrice.old ? activePrice.old : (activePrice.value + basePrice);

        total += value;
      }

      if (item.path.includes('movel') && !mobileBaseChosen.path) {
        return false;
      }

      if (!item.path.includes('movel')) {
        const activePrice = rootGetters['cart/getPathPrice'](item.path);
        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
        const value = item.quantity * (activePrice.value + basePrice);

        total += value;
      }
      return true;
    }

    const activePrice = rootGetters['cart/getPathPrice'](item.path);
    const basePrice = activePrice.absolute ? 0 : item.config.basePrice;
    const value = item.quantity * (activePrice.value + basePrice);

    total += value;

    return true;
  });

  return total + getters.getTotalHiddenAdditionalServicesPrice;
};

export const getTotalMobileBaseServicesPrice = (state, getters, rootState, rootGetters) => {
  if (!rootState.cart.content) {
    return 0;
  }

  let total = 0;

  const filteredItems = getters.getBaseServices.filter(item =>
    !item.config.isUnaccountable && (
      item.config.namespace === 'plano' || item.config.namespace === 'movel' || item.config.namespace === 'movel_adicionais'
    ));

  filteredItems.map((item) => {
    if (rootGetters['offers/isPathAnOffer'](item.path)) {
      return false;
    }

    const activePrice = rootGetters['cart/getPathPrice'](item.path);
    const basePrice = activePrice.absolute ? 0 : item.config.basePrice;

    let value = 0;
    if (activePrice.old) {
      value = item.quantity * (activePrice.old + basePrice);
    } else {
      value = item.quantity * (activePrice.value + basePrice);
    }

    total += value;

    return true;
  });

  return total + getters.getTotalHiddenAdditionalServicesPrice;
};

export const getTotalBaseServicesPriceWithoutDiscounts = (state, getters, rootState, rootGetters) => {
  const totalBaseServicesPrice = getters.getTotalBaseServicesPrice;
  const discountOffersValue = rootGetters['offers/getValidDiscountOffersValue'];

  return totalBaseServicesPrice + discountOffersValue;
};

export const getTotalNonFidelizedBaseServicesPrice = (state, getters, rootState, rootGetters) => {
  if (!rootState.cart.content) {
    return 0;
  }

  let total = 0;

  const filteredItems = getters.getBaseServices.filter(item => !item.config.isUnaccountable);

  const mobileItems = filteredItems.filter(i => i.path.includes('movel') || i.path.includes('plano'));
  const mobileBaseChosen = mobileItems[mobileItems.length - 1];
  const packageName = rootGetters['packages/getActivePackageMeta'].name;

  filteredItems.map((item) => {
    if (rootGetters['offers/isPathAnOffer'](item.path)) {
      return false;
    }

    if (packageName.toLowerCase() === 'pospago') {
      if (item.path !== mobileBaseChosen.path) {
        return false;
      }

      if (item.path === mobileBaseChosen.path) {
        const activePrice = rootGetters['cart/getPathNonFidelizedPrice'](item.path);
        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;

        const value = activePrice.value + basePrice;

        total += value;
      }
      return true;
    }

    if (packageName.toLowerCase() === 'casa') {
      if (mobileItems.length && item.path === mobileBaseChosen.path) {
        const activePrice = rootGetters['cart/getPathNonFidelizedPrice'](item.path);
        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;

        const value = activePrice.value + basePrice;

        total += value;
      }
      if (item.path.includes('movel') && !mobileBaseChosen.path) {
        return false;
      }
      if (!item.path.includes('movel')) {
        const activePrice = rootGetters['cart/getPathNonFidelizedPrice'](item.path);
        const basePrice = activePrice.absolute ? 0 : item.config.basePrice;

        const value = item.quantity * (activePrice.value + basePrice);

        total += value;
      }

      return true;
    }

    const activePrice = rootGetters['cart/getPathNonFidelizedPrice'](item.path);
    const basePrice = activePrice.absolute ? 0 : item.config.basePrice;

    const value = item.quantity * (activePrice.value + basePrice);

    total += value;


    return true;
  });

  return total;
};

export const getTotalNonFidelizedMobilBaseServicesPrice = (state, getters, rootState, rootGetters) => {
  if (!rootState.cart.content) {
    return 0;
  }

  let total = 0;

  const filteredItems = getters.getBaseServices.filter(item =>
    !item.config.isUnaccountable && (
      item.config.namespace === 'plano' || item.config.namespace === 'movel' || item.config.namespace === 'movel_adicionais'
    ));

  filteredItems.map((item) => {
    if (rootGetters['offers/isPathAnOffer'](item.path)) {
      return false;
    }

    const activePrice = rootGetters['cart/getPathNonFidelizedPrice'](item.path);
    const basePrice = activePrice.absolute ? 0 : item.config.basePrice;

    const value = item.quantity * (activePrice.value + basePrice);

    total += value;

    return true;
  });

  getters.getAdditionalMobileServices.forEach((item) => {
    const nonFidelizedPrice = rootGetters['cart/getPathNonFidelizedPrice'](item.path).value;
    const activePrice = rootGetters['cart/getPathPrice'](item.path).value;

    total += (nonFidelizedPrice - activePrice) * item.quantity;
  });

  return total;
};

export const getTotalAdditionalMovelServicesPrice = (state, getters, rootState, rootGetters) => {
  if (!rootState.cart.content) {
    return 0;
  }

  let total = 0;
  const filteredItems = getters.getAdditionalServices.filter(item => !item.config.isUnaccountable && item.path.includes('movel_adicionais'));

  filteredItems.map((item) => {
    if (rootGetters['offers/isPathAnOffer'](item.path)) {
      return false;
    }

    const activePrice = rootGetters['cart/getPathPrice'](item.path);
    const nonFidelizedPrice = rootGetters['cart/getPathNonFidelizedPrice'](item.path).value;

    const basePrice = activePrice.absolute ? 0 : item.config.basePrice;

    const value = item.quantity * (nonFidelizedPrice - (activePrice.value + basePrice));

    total += value;

    return true;
  });

  return total;
};

export const generateNonFidelizedOffers = (state, getters, rootState, rootGetters) => {
  let content = [];
  const total = null;
  const offers = [
    { offer: '2GB', title: 'Oferta de 2GB/cartão de 1GB durante 24 meses mediante ativação na App Área de Cliente, até 30 dias após ativação do serviço.' },
    { offer: '6GB', title: 'Oferta de 6GB/cartão de 15GB durante 24 meses mediante ativação na App Área de Cliente, até 30 dias após ativação do serviço.' }
  ];

  const validOffers = rootGetters['offers/getValidOffers'];
  const hasCampaign = offers.filter(offerDetail => validOffers.some(validOffer => validOffer.description.includes(offerDetail.offer)));

  if (hasCampaign.length > 0) {
    let title = '';

    if (hasCampaign.length === 1) {
      title = hasCampaign[0].title;
    } else if (hasCampaign.length === 2) {
      title = `${hasCampaign[0].title} <br /> ${hasCampaign[1].title}`;
    }

    content.push({
      title
    });
  } else {
    content = null;
  }

  return {
    total,
    content
  };
};

export const getTotalPrice = (state, getters) => getters.getTotalAdditionalServicesPrice + getters.getTotalBaseServicesPrice;

export const getTotalPriceWithoutDiscounts = (state, getters) => getters.getTotalAdditionalServicesPrice + getters.getTotalBaseServicesPriceWithoutDiscounts;

export const getTotalNonFidelizedPrice = (state, getters) => getters.getTotalAdditionalNonFidelizedServicesPrice + getters.getTotalNonFidelizedBaseServicesPrice;

export const getModalVisibility = state => state.isModalVisible;

export default {
  getAdditionalServices,
  getHiddenAdditionalServices,
  getTotalHiddenAdditionalServicesPrice,
  getBaseServices,
  getAdditionalMobileServices,
  getTotalAdditionalServicesPrice,
  getTotalAdditionalServicesPriceWithPeriodicOffer,
  getTotalBaseServicesPrice,
  getTotalMobileBaseServicesPrice,
  getTotalBaseServicesPriceWithoutDiscounts,
  getTotalPrice,
  getTotalPriceWithoutDiscounts,
  getTotalAdditionalNonFidelizedServicesPrice,
  getTotalNonFidelizedBaseServicesPrice,
  getTotalNonFidelizedMobilBaseServicesPrice,
  getTotalNonFidelizedPrice,
  generateFidelizedOffers,
  generateNonFidelizedOffers,
  generateContent,
  getModalVisibility,
  getTotalAdditionalMovelServicesPrice,
  getTotalAdditionalOldServicesPrice
};



// WEBPACK FOOTER //
// ./src/store/modules/fis/getters.js